import { render, staticRenderFns } from "./NewtabIcon.vue?vue&type=template&id=0c3cd257&"
import script from "./NewtabIcon.vue?vue&type=script&lang=js&"
export * from "./NewtabIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports